/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Tpl_Cta_DescInputs */

const en_fw_tpl_cta_desc = /** @type {(inputs: Fw_Tpl_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once 5 tasks of a plan pass verification, you can publish it here from the plan list. Code never leaves your machine.`)
};

const id_fw_tpl_cta_desc = /** @type {(inputs: Fw_Tpl_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begitu 5 task sebuah rencana lolos verifikasi, kamu bisa menerbitkannya di sini dari daftar rencana. Kode tidak pernah keluar dari mesinmu.`)
};

/**
* | output |
* | --- |
* | "Once 5 tasks of a plan pass verification, you can publish it here from the plan list. Code never leaves your machine." |
*
* @param {Fw_Tpl_Cta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_cta_desc = /** @type {((inputs?: Fw_Tpl_Cta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_Cta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_cta_desc(inputs)
	return en_fw_tpl_cta_desc(inputs)
});